document.addEventListener('DOMContentLoaded', function () {
  var buyNowButton = document.getElementById('BuyNowButton');
  if (buyNowButton) {
    buyNowButton.addEventListener('click', function () {
      window.location.href = '/checkout';
    });
  }
});

(function () {
  'use strict';

  var OPEN_CLASS = 'mc-drawer-open';
  var refreshPromise = null;
  var refreshSequence = 0;
  var cartMutationQueue = Promise.resolve();
  var lockedScrollY = 0;
  var closeTimer = null;

  function getDrawer() {
    return document.getElementById('mini-cart');
  }

  function getToggleButtons() {
    return document.querySelectorAll('[data-action="toggle-mini-cart"]');
  }

  function getRoute(name, fallback) {
    return window.routes && window.routes[name] ? window.routes[name] : fallback;
  }

  function jsonEndpoint(route) {
    return route.replace(/\/$/, '') + '.js';
  }

  function addQueryString(url, params) {
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return url + separator + params;
  }

  function noop() {}

  function queueCartMutation(worker) {
    cartMutationQueue = cartMutationQueue.catch(noop).then(worker);
    return cartMutationQueue;
  }

  function cartRequest(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }

  function changeCart(payload) {
    return cartRequest(jsonEndpoint(getRoute('cartChangeUrl', '/cart/change')), payload);
  }

  function addToCart(payload) {
    return cartRequest(jsonEndpoint(getRoute('cartAddUrl', '/cart/add')), payload);
  }

  function lockPageScroll() {
    if (document.body.classList.contains('mc-scroll-locked')) return;

    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('mc-scroll-locked');
    document.body.classList.add('mc-scroll-locked');
    document.body.style.top = '-' + lockedScrollY + 'px';
  }

  function unlockPageScroll() {
    if (!document.body.classList.contains('mc-scroll-locked')) return;

    document.documentElement.classList.remove('mc-scroll-locked');
    document.body.classList.remove('mc-scroll-locked');
    document.body.style.top = '';
    window.scrollTo(0, lockedScrollY);
  }

  function setDrawerState(open) {
    var drawer = getDrawer();

    document.body.classList.toggle(OPEN_CLASS, open);

    if (open) {
      lockPageScroll();
    } else {
      unlockPageScroll();
    }

    if (drawer) {
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    getToggleButtons().forEach(function (button) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    document.body.classList.toggle('no-mobile-scroll', open);
  }

  function openDrawer() {
    window.clearTimeout(closeTimer);
    document.body.classList.remove('mc-drawer-closing');
    setDrawerState(true);
  }

  function closeDrawer() {
    if (document.body.classList.contains(OPEN_CLASS)) {
      window.clearTimeout(closeTimer);
      document.body.classList.add('mc-drawer-closing');
      closeTimer = window.setTimeout(function () {
        document.body.classList.remove('mc-drawer-closing');
      }, 430);
    }

    setDrawerState(false);
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.header__cart-count, .mc-header__badge').forEach(function (el) {
      el.textContent = count;
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }

    var value = (cents / 100).toFixed(2).replace('.', ',');
    return '$' + value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function getCompareTotal(cart) {
    return cart.items.reduce(function (total, item) {
      return total + (item.original_line_price || item.final_line_price || 0);
    }, 0);
  }

  function paymentIconHtml(drawer, key, alt) {
    var src = drawer && drawer.getAttribute('data-payment-' + key);
    return src ? '<img src="' + src + '" alt="' + alt + '" loading="lazy" decoding="async" height="22">' : '';
  }

  function buildFooterHtml(cart) {
    var drawer = getDrawer();
    var compareTotal = getCompareTotal(cart);
    var savings = Math.max(compareTotal - cart.total_price, 0);

    return [
      '<div class="mc-footer">',
        '<div class="mc-footer__total-row">',
          '<span class="mc-footer__total-label">Total</span>',
          '<div class="mc-footer__total-values">',
            savings > 0 ? '<s class="mc-footer__original-price">' + formatMoney(compareTotal) + '</s>' : '',
            '<span class="mc-footer__final-price">' + formatMoney(cart.total_price) + '</span>',
            savings > 0 ? '<span class="mc-footer__savings-badge">-' + formatMoney(savings) + '</span>' : '',
          '</div>',
        '</div>',
        '<div class="mc-footer__shipping">',
          '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="17" height="17"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="#22c55e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
          '<span>ENVIO GRATIS</span>',
        '</div>',
        '<a href="/checkout" class="mc-footer__checkout-btn">',
          '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="17" height="17"><path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
          'PAGAR AHORA',
        '</a>',
        '<div class="mc-footer__payments">',
          paymentIconHtml(drawer, 'visa', 'Visa'),
          paymentIconHtml(drawer, 'amex', 'Amex'),
          paymentIconHtml(drawer, 'master', 'Mastercard'),
          paymentIconHtml(drawer, 'diners', 'Diners'),
          paymentIconHtml(drawer, 'discover', 'Discover'),
          paymentIconHtml(drawer, 'shoppay', 'Shop Pay'),
          paymentIconHtml(drawer, 'apple', 'Apple Pay'),
          paymentIconHtml(drawer, 'google', 'Google Pay'),
        '</div>',
      '</div>'
    ].join('');
  }

  function ensureFooter(cart) {
    var drawer = getDrawer();
    if (!drawer || cart.item_count < 1) return;

    var footer = drawer.querySelector('.mc-footer');
    if (!footer) {
      drawer.insertAdjacentHTML('beforeend', buildFooterHtml(cart));
    }
  }

  function normalizeRecommendations() {
    var drawer = getDrawer();
    if (!drawer) return;

    drawer.querySelectorAll('.mc-rec-item__add-btn').forEach(function (button) {
      button.classList.remove('is-loading');
      button.disabled = false;
      if (!button.textContent.trim() || button.textContent.trim() === 'OK') {
        button.textContent = '+ AGREGAR';
      }
    });
  }

  function fetchCartJson(signal) {
    return fetch(jsonEndpoint(getRoute('cartUrl', '/cart')), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      signal: signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart JSON failed');
      return response.json();
    });
  }

  function fetchFreshDrawerHtml(signal) {
    var url = addQueryString(getRoute('cartUrl', '/cart'), 'view=mini-cart&mc_refresh=' + Date.now());

    return fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Drawer HTML failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.getElementById('mini-cart');
      });
  }

  function replaceDrawer(freshDrawer, isOpen) {
    var currentDrawer = getDrawer();
    if (!currentDrawer || !freshDrawer) return;

    freshDrawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    currentDrawer.replaceWith(freshDrawer);
  }

  function refreshDrawer(options) {
    options = options || {};

    var requestId = ++refreshSequence;
    var shouldOpen = options.open !== false;

    document.body.classList.add('mc-drawer-loading');

    refreshPromise = Promise.all([fetchCartJson(), fetchFreshDrawerHtml()])
      .then(function (results) {
        var cart = results[0];
        var freshDrawer = results[1];

        if (requestId !== refreshSequence) return cart;

        updateHeaderCount(cart.item_count);
        replaceDrawer(freshDrawer, shouldOpen || document.body.classList.contains(OPEN_CLASS));
        ensureFooter(cart);
        normalizeRecommendations();

        if (shouldOpen) {
          openDrawer();
        }

        return cart;
      })
      .finally(function () {
        if (requestId === refreshSequence) {
          document.body.classList.remove('mc-drawer-loading');
          refreshPromise = null;
        }
      });

    return refreshPromise;
  }

  document.addEventListener('click', function (event) {
    var toggleBtn = event.target.closest('[data-action="toggle-mini-cart"]');
    if (!toggleBtn) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (document.body.classList.contains(OPEN_CLASS)) {
      closeDrawer();
    } else {
      refreshDrawer({ open: true }).catch(openDrawer);
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (
      document.body.classList.contains(OPEN_CLASS) &&
      !event.target.closest('.mini-cart') &&
      !event.target.closest('[data-action="toggle-mini-cart"]')
    ) {
      event.preventDefault();
      event.stopPropagation();
      closeDrawer();
      return;
    }

    if (event.target.closest('.mc-close-drawer')) {
      closeDrawer();
      return;
    }

    if (event.target.closest('.mc-footer__checkout-btn')) {
      closeDrawer();
      return;
    }

    var quantityBtn = event.target.closest('.mc-item__quantity-btn');
    if (quantityBtn && !quantityBtn.disabled) {
      event.preventDefault();

      var selector = quantityBtn.closest('.mc-item__quantity-selector');
      var quantityItem = quantityBtn.closest('.mc-item');
      var quantityBadge = selector && selector.querySelector('.mc-item__qty-badge');
      var action = quantityBtn.getAttribute('data-quantity-action');
      var quantityKey = selector && selector.getAttribute('data-item-key');
      var currentQuantity = quantityBadge ? parseInt(quantityBadge.textContent, 10) : 1;
      var nextQuantity = action === 'increase' ? currentQuantity + 1 : currentQuantity - 1;

      if (!quantityKey || !Number.isFinite(nextQuantity)) return;
      nextQuantity = Math.max(0, nextQuantity);

      selector.classList.add('is-updating');
      selector.querySelectorAll('button').forEach(function (button) {
        button.disabled = true;
      });

      if (quantityBadge) quantityBadge.textContent = nextQuantity;
      if (nextQuantity === 0 && quantityItem) quantityItem.classList.add('is-removing');

      queueCartMutation(function () {
        return changeCart({ id: quantityKey, quantity: nextQuantity }).then(function () {
          return refreshDrawer({ open: true });
        });
      }).catch(function () {
          if (quantityItem) quantityItem.classList.remove('is-removing');
          if (quantityBadge) quantityBadge.textContent = currentQuantity;
          selector.classList.remove('is-updating');
          selector.querySelectorAll('button').forEach(function (button) {
            button.disabled = false;
          });
      });

      return;
    }

    var removeBtn = event.target.closest('.mc-item__remove-btn');
    if (removeBtn && !removeBtn.disabled) {
      event.preventDefault();

      var key = removeBtn.getAttribute('data-item-key');
      var item = removeBtn.closest('.mc-item');
      if (!key) return;

      removeBtn.disabled = true;
      removeBtn.textContent = '...';
      if (item) item.classList.add('is-removing');

      queueCartMutation(function () {
        return changeCart({ id: key, quantity: 0 }).then(function () {
          return refreshDrawer({ open: true });
        });
      }).catch(function () {
          if (item) item.classList.remove('is-removing');
          removeBtn.disabled = false;
          removeBtn.textContent = 'Eliminar';
      });

      return;
    }

    var addBtn = event.target.closest('.mc-rec-item__add-btn');
    if (addBtn && !addBtn.disabled) {
      event.preventDefault();

      var recItem = addBtn.closest('.mc-rec-item');
      var recVariantSelect = recItem && recItem.querySelector('.mc-rec-item__variant-selector');
      var variantId = recVariantSelect ? recVariantSelect.value : addBtn.getAttribute('data-variant-id');
      var originalText = addBtn.textContent;
      if (!variantId) return;

      addBtn.disabled = true;
      addBtn.classList.add('is-loading');
      if (recVariantSelect) recVariantSelect.disabled = true;
      addBtn.textContent = '...';

      queueCartMutation(function () {
        return addToCart({ id: parseInt(variantId, 10), quantity: 1 }).then(function () {
          addBtn.textContent = 'OK';
          return refreshDrawer({ open: true });
        });
      }).catch(function () {
          addBtn.disabled = false;
          addBtn.classList.remove('is-loading');
          if (recVariantSelect) recVariantSelect.disabled = false;
          addBtn.textContent = originalText;
      });
    }
  });

  document.addEventListener('change', function (event) {
    var variantSelect = event.target.closest('.mc-item__variant-selector');
    if (!variantSelect || variantSelect.disabled) return;

    var oldKey = variantSelect.getAttribute('data-item-key');
    var newVariantId = parseInt(variantSelect.value, 10);
    var quantity = parseInt(variantSelect.getAttribute('data-current-quantity'), 10) || 1;
    var variantItem = variantSelect.closest('.mc-item');

    if (!oldKey || !Number.isFinite(newVariantId)) return;

    variantSelect.disabled = true;
    variantSelect.classList.add('is-updating');
    if (variantItem) variantItem.classList.add('is-updating');

    queueCartMutation(function () {
      return changeCart({ id: oldKey, quantity: 0 }).then(function () {
        return addToCart({ id: newVariantId, quantity: quantity });
      }).then(function () {
        return refreshDrawer({ open: true });
      });
    }).catch(function () {
        variantSelect.disabled = false;
        variantSelect.classList.remove('is-updating');
        if (variantItem) variantItem.classList.remove('is-updating');
        refreshDrawer({ open: true }).catch(function () {});
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.body.classList.contains(OPEN_CLASS)) {
      closeDrawer();
    }
  });

  document.addEventListener('product:added', function () {
    window.setTimeout(function () {
      cartMutationQueue.then(function () {
        return refreshDrawer({ open: true });
      }).catch(openDrawer);
    }, 250);
  });

  document.addEventListener('cart:refresh', function () {
    var shouldOpen = document.body.classList.contains(OPEN_CLASS);

    if (shouldOpen) {
      cartMutationQueue.then(function () {
        return refreshDrawer({ open: true });
      }).catch(function () {});
      return;
    }

    cartMutationQueue.then(function () {
      return fetchCartJson();
    }).then(function (cart) {
      updateHeaderCount(cart.item_count);
    }).catch(function () {});
  });

  document.addEventListener('DOMContentLoaded', function () {
    setDrawerState(false);
    fetchCartJson().then(function (cart) {
      updateHeaderCount(cart.item_count);
    }).catch(function () {});
  });
})();
